module.exports = __webpack_public_path__ + "ac879dd7b12abf7c394cde4f73d42f0e.pdf";